import request from '@/plugins/request/system';



/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiPubIndex(data = {}) {
  return request({
    url: '/api/index/getPubIndex',
    method: 'post',
    data : data
  });
}


/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiPubIndex2(data = {}) {
  return request({
    url: '/api/index/getPubIndex2',
    method: 'post',
    data : data
  });
}

/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiIndex(data = {}) {
  return request({
    url: '/api/index/sysInit',
    method: 'post',
    data : data
  });
}


/**
 * 获取幻灯片
 * @param data
 * @constructor
 */
export function ApiPubSlide(data = {}) {
  return request({
    url: '/api/index/getPubSilde',
    method: 'post',
    data : data
  });
}



/**
 * 新闻列表数据
 * @param data
 * @constructor
 */
export function ApiPubNewsList(data = {}) {
  return request({
    url: '/api/index/getNewsList',
    method: 'post',
    data : data
  });
}


/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiPubContent(data = {}) {
  return request({
    url: '/api/index/getContent',
    method: 'post',
    data : data
  });
}


/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiPubCateInit(data = {}) {
  return request({
    url: '/api/index/getCateInit',
    method: 'post',
    data : data
  });
}




/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiPubManpower(data = {}) {
  return request({
    url: '/api/index/getManpower',
    method: 'post',
    data : data
  });
}


/**
 * 人才招聘列表
 * @param data
 * @constructor
 */
export function ApiPubManpowerList(data = {}) {
  return request({
    url: '/api/index/getManpowerList',
    method: 'post',
    data : data
  });
}



/**
 * 护理科普
 * @param data
 * @constructor
 */
export function ApiPubNurseList(data = {}) {
  return request({
    url: '/api/index/getNurseList',
    method: 'post',
    data : data
  });
}


/**
 * 护理科普详情
 * @param data
 * @constructor
 */
export function ApiPubNurseItem(data = {}) {
  return request({
    url: '/api/index/getNurseItem',
    method: 'post',
    data : data
  });
}




/**
 * 护理科普详情
 * @param data
 * @constructor
 */
export function ApiKsListTree() {
  return request({
    url: '/api/index/getkSListTree',
    method: 'get'
  });
}

/**
 * 护理科普详情
 * @param data
 * @constructor
 */
export function ApiKsList() {
  return request({
    url: '/api/index/getkSList',
    method: 'get'
  });
}


/**
 * 科室详情
 * @param data
 * @constructor
 */
export function ApiKsItem(data = {}) {
  return request({
    url: '/api/index/getKsItem',
    method: 'post',
    data : data
  });
}





/**
 * 科室详情
 * @param data
 * @constructor
 */
export function ApiExpertList(data = {}) {
  return request({
    url: '/api/index/getExpertList',
    method: 'post',
    data : data
  });
}


/**
 * 科室列表
 * @param data
 * @constructor
 */
export function ApiExpertListPage(data = {}) {
  return request({
    url: '/api/index/getExpertListPage',
    method: 'post',
    data : data
  });
}

/**
 * 专家详情
 * @param data
 * @constructor
 */
export function ApiExpertItem(data = {}) {
  return request({
    url: '/api/index/getExpertItem',
    method: 'post',
    data : data
  });
}
























/**
 * 获取产品列表
 * @param data
 * @constructor
 */
export function ApiEnterpriseList(data = {}) {
  return request({
    url: '/api/index/enterprise',
    method: 'post',
    data : data
  });
}



/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiSubIndex(data = {}) {
  return request({
    url: '/api/index/subIndex',
    method: 'post',
    data : data
  });
}
/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiGetQuestion(data = {}) {
  return request({
    url: '/api/index/getQuestion',
    method: 'post',
    data : data
  });
}


/**
 * 获取首页基础信息
 * @param data
 * @constructor
 */
export function ApiCheck(data = {}) {
  return request({
    url: '/api/index/check',
    method: 'post',
    data : data
  });
}



/**
 * 提交招聘资料
 * @param data
 * @constructor
 */
export function ApiIndexJobSub(data = {}) {
  return request({
    url: '/api/index/jobSub',
    method: 'post',
    data : data
  });
}



// WEBPACK FOOTER //
// ./src/api/api/index.js